export const useStopScrollPropagationProps = (): React.HTMLAttributes<HTMLDivElement> => {
  return {
    onScroll: (e) => e.stopPropagation(),
    onWheel: (e) => e.stopPropagation(),
    onTouchMove: (e) => e.stopPropagation(),
  };
};
